module.exports = __webpack_public_path__ + "img/savings_usd.f301e40b.png";